import { ArrowForward } from '@mui/icons-material';
import { Button, FormControl, Stack, Typography } from '@mui/material';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import { FormattedMessage } from 'react-intl';
import { OutlinedInfoBar } from '../../../../components/_DesignSystemWrappers/InfoBar/OutlinedInfoBar';
import { PasswordInput } from '../../../../components/HookFormFields/PasswordInput';
import { PATHS } from '../../../../config/consts';
import { RouterLink } from '../../../ResetPasswordPage/components/Link/PrimaryLink';
import messages from '../../messages';
import { Animation } from './Animation';

const PasswordFieldHeight = 103;

export interface IAuthLoginFormData {
  isSubmitDisabled: boolean;
  isSSOLogin: boolean;
}

export function AuthLoginForm({ isSSOLogin, isSubmitDisabled }: IAuthLoginFormData) {
  return (
    <FormControl fullWidth>
      <Stack mb={2}>
        <OutlinedTextField
          id="username-input"
          label={<FormattedMessage {...messages.authLoginEmailLabel} />}
          name="email"
          required
          autoFocus
          type="email"
        />
        <Animation isChildVisible={!isSSOLogin} height={PasswordFieldHeight}>
          <PasswordInput
            id="password-input"
            label={<FormattedMessage {...messages.authLoginPasswordLabel} />}
            name="password"
            required
            type="password"
          />
        </Animation>
        <Button
          fullWidth
          startIcon={<ArrowForward />}
          color="primary"
          disabled={isSubmitDisabled}
          id="login-button"
          size="large"
          sx={{ mt: 1 }}
          type="submit"
          variant="contained"
        >
          <FormattedMessage {...(isSSOLogin ? messages.authLoginSubmitSSO : messages.authLoginSubmit)} />
        </Button>
      </Stack>
      <Animation height="fit-content" isChildVisible={!isSSOLogin}>
        <RouterLink styles={{ mb: 2 }} to={PATHS.PASSWORD_RESET}>
          <span data-testid="forgotten-password-link">
            <FormattedMessage {...messages.authLoginForgottenPassword} />
          </span>
        </RouterLink>
        <OutlinedInfoBar>
          <Typography component="div">
            <FormattedMessage {...messages.authLoginUnregisteredText} />
            <RouterLink styles={{ display: 'inline' }} to={PATHS.REGISTER}>
              <FormattedMessage {...messages.authLoginUnregisteredAction} />
            </RouterLink>
          </Typography>
        </OutlinedInfoBar>
      </Animation>
    </FormControl>
  );
}
